module.exports = __webpack_public_path__ + "static/img/作品32.439ed31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品32.png
// module id = 2PZ+
// module chunks = 1